import i18n, {InitOptions} from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import {initReactI18next} from 'react-i18next';
import {registerSharedTranslations} from '@chekin/shared';
import {registerUiKitI18n} from '@chekinapp/ui';
import {preloadAndSetDayJsLocale, LANGUAGE_CODES} from '@chekin/core';
import {LazyImport} from './plugins/lazyImportPlugin';

const defaultLanguages = {
  es: [LANGUAGE_CODES.ca],
};

i18n.on('languageChanged', function (nextLanguage) {
  const fallbackLanguage = Object.keys(defaultLanguages).find(key => {
    return defaultLanguages[key as keyof typeof defaultLanguages].includes(
      nextLanguage as LANGUAGE_CODES,
    );
  });

  void preloadAndSetDayJsLocale(fallbackLanguage || nextLanguage);
});

const initParams: InitOptions = {
  fallbackLng: LANGUAGE_CODES.en,
  detection: {
    order: ['querystring', 'localStorage', 'navigator'],
  },
  load: 'languageOnly',
  interpolation: {
    escapeValue: false,
  },
  preload: [LANGUAGE_CODES.it, LANGUAGE_CODES.es, LANGUAGE_CODES.de],
  returnNull: false,
  returnEmptyString: false,
  fallbackNS: 'translation',
  react: {
    bindI18nStore: 'added',
    transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p', 'ul', 'li'],
  },
};

void i18n
  .use(LazyImport)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init(initParams, () => {
    registerSharedTranslations(i18n);
    registerUiKitI18n(i18n);
  });

export {i18n};
